export const AllGenreParameter = "All";
export const ReleaseDate = "releaseDate";